import React from 'react';
import { useGetItemsQuery } from '../store/docApi';
import { Box, Card, CardContent, CardMedia, Typography, CircularProgress } from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import { Link } from 'react-router-dom';

export default function ProjectList() {
  const { data, error, isLoading } = useGetItemsQuery({ label: 'project' });

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography color="error" align="center" sx={{ mt: 4 }}>
        Failed to load projects: {error.message}
      </Typography>
    );
  }

  if (!data || data.length === 0) {
    return (
      <Typography align="center" sx={{ mt: 4 }}>
        No projects found.
      </Typography>
    );
  }

  return (
    <Box>
      <Typography variant="h4" align="center" gutterBottom>
        Projects
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 3,
          justifyContent: 'center'
        }}
      >
        {data.map((project) => (
          <Box
            key={project.id}
            sx={{
              width: { xs: '100%', sm: 'calc(50% - 24px)', md: 'calc(33.33% - 24px)', lg: 'calc(25% - 24px)' }
            }}
          >
            <Link to={`/projects/${project.pk}/${project.id}`} style={{ textDecoration: 'none', display: 'block' }}>
              <Card
                variant="outlined"
                sx={{
                  height: '100%',
                  transition: 'box-shadow 0.2s ease-in-out',
                  '&:hover': {
                    boxShadow: 1
                  }
                }}
              >
                {project.picture ? (
                  <CardMedia
                    component="img"
                    image={project.picture}
                    alt={project.name || 'Project'}
                    sx={{ height: 140, objectFit: 'cover' }}
                  />
                ) : (
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: 140,
                      backgroundColor: 'grey.200'
                    }}
                  >
                    <FolderIcon sx={{ fontSize: 48, color: 'grey.500' }} />
                  </Box>
                )}
                <CardContent>
                  <Typography variant="h6">{project.name || 'Unnamed Project'}</Typography>
                  {project.description && (
                    <Typography variant="body2" color="text.secondary">
                      {project.description}
                    </Typography>
                  )}
                </CardContent>
              </Card>
            </Link>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
